import { Controller } from "stimulus";
export default class extends Controller {
  static targets = ["template", "scheduleSection"];

  connect() {
    document.addEventListener('promote:editor-dragend', this._onDragEnd.bind(this));
  }

  disconnect() {
    document.removeEventListener('promote:editor-dragend', this._onDragEnd.bind(this));
  }

  _onDragEnd(event) {
    setTimeout(() => {
      this._updateItemCounters();
    }, 100);
  }

  addScheduleItem(event) {
    event.preventDefault();

    let newForm = this.templateTarget.cloneNode(true);
    newForm.dataset.programBuilderScheduleTarget = '';

    const items = this.scheduleSectionTarget.querySelectorAll('.js-editor-schedule-item');

    if (items.length) {
      const lastItem = items[items.length - 1];

      lastItem.after(newForm);
    } else {
      scheduleSection.append(newForm);
    }

    newForm.dataset['editor-ScheduleTarget'] = '';
    newForm.querySelector('.js-schedule-item-content').classList.remove('collapsed');
    newForm.classList.remove("hidden");
    newForm.scrollIntoView({ behavior: "smooth", block: 'nearest', inline: "center"});

    // Enable validation on cloned template fields
    const headerInput = newForm.querySelector('input[name*="[header]"]');
    if (headerInput) {
      headerInput.setAttribute('required', true);
    }

    this._updateItemCounters();
  }

  removeScheduleItem(event) {
    event.preventDefault();

    let scheduleItem = event.target.closest(".js-editor-schedule-item");

    scheduleItem.remove();

    this._updateItemCounters();
  }

  _updateItemCounters() {
    const visibleItems = document.querySelectorAll('.js-editor-schedule-item:not(.hidden)');

    visibleItems.forEach((item, index) => {
      this._updateFormNames(item, index + 1);
    });
  }

  _updateFormNames(element, counterStrings) {
    var fields = element.querySelectorAll('[name]');

    fields.forEach(field => {
      if (field.name.includes('_index_')) {
        field.name = field.name.replace('_index_', counterStrings);
        field.id = field.id.replace('_index_', counterStrings);
      } else {
        field.name = field.name.replace(/\d+/, counterStrings);
        field.id = field.id.replace(/\d+/, counterStrings);
      }
    });
  }
}
